module.exports = __webpack_public_path__ + "img/4_117.c288cd9b.png";